import useSettings from '@/queries/useSettings';
import { useRouter } from 'next/router';

type PriceProps = {
  price: number;
  className?: string;
};

const roundTo = (value: number, decimals = 2): number => {
  const factor = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * factor) / factor;
};

export const Price = ({ price, className }: PriceProps) => {
  const router = useRouter();
  const lang = (router.locale ?? 'en').split('-')[0];
  const usdExchangeRateSetting = useSettings('USD_EXCHANGE_RATE');
  const customCurrencySetting = useSettings(`CURRENCY_${lang.toUpperCase()}`);
  const usdExchangeRate = Number(usdExchangeRateSetting?.value) || 1;

  let displayPrice = price.toLocaleString('vi-VN', {
    maximumFractionDigits: 0,
  });
  let unit = 'VND';

  if (lang !== 'vi') {
    displayPrice = roundTo(price / usdExchangeRate, 2).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    unit = 'USD';
  }

  if (lang !== 'vi' && lang !== 'en') {
    unit = customCurrencySetting.keyword || customCurrencySetting.value || unit;
  }
  const mergedClassName = [className, 'tabular-nums'].filter(Boolean).join(' ');

  return <span className={mergedClassName}>{displayPrice} {unit}</span>;
};

export default Price;
